import { render, staticRenderFns } from "./SettingCountry.vue?vue&type=template&id=40b85a72&"
import script from "./SettingCountry.vue?vue&type=script&lang=js&"
export * from "./SettingCountry.vue?vue&type=script&lang=js&"
import style0 from "./SettingCountry.vue?vue&type=style&index=0&id=40b85a72&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports